export const GET_HOST_COMMISSION = "GET_HOST_COMMISSION";
export const CREATE_NEW_HOST_COMMISSION = "CREATE_NEW_HOST_COMMISSION";
export const EDIT_HOST_COMMISSION = "EDIT_HOST_COMMISSION";
export const DELETE_HOST_COMMISSION = "DELETE_HOST_COMMISSION";

export const VIP_SWITCH = "VIP_SWITCH";

export const OPEN_HOST_COMMISSION_DIALOG = "OPEN_HOST_COMMISSION_DIALOG";
export const CLOSE_HOST_COMMISSION_DIALOG = "CLOSE_HOST_COMMISSION_DIALOG";
